import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import { getNextBillingDate } from 'utils';

import styles from './styles.pcss';
import { BillingDateProps } from './types';

const cn = classNames.bind(styles);

export const BillingDate: FC<BillingDateProps> = ({ text, billingDate }) => {
  const nextBillingDate = getNextBillingDate(billingDate);

  return (
    <div className={cn('component')}>
      <div className={cn('divider')} />
      <Text color="grey60" size="size5-r-s">
        {text} {billingDate && <span>{nextBillingDate}</span>}
      </Text>
    </div>
  );
};
